import React from "react";
import useSWR from "swr";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, PartyPopper } from "lucide-react";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";
import SectionHeading from "@/components/SectionHeading";

const fetcher = (url) => api.get(url).then((r) => r.data);

export default function Events() {
  const { data: events } = useSWR("/events", fetcher);
  return (
    <div className="pt-32 pb-24">
      <Seo title="Events | Keys Event Center" description="Birthday parties, family reunions, holiday parties, school trips, youth groups, corporate events, church groups and team celebrations, all in your private venue." />
      <div className="mx-auto max-w-7xl px-6">
        <SectionHeading eyebrow="Any Occasion, Elevated" title="Events We Host" subtitle="Whatever you're celebrating, the whole place is yours. Beautiful, private, and unforgettable." />
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {(events || []).map((ev, i) => (
            <motion.div key={ev.slug} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 3) * 0.08 }}
              className="card card-lift group relative overflow-hidden" data-testid={`event-card-${ev.slug}`}>
              <div className="relative h-32 overflow-hidden flex items-center justify-center bg-gradient-to-br from-[#2a1a12] via-[#3a241a] to-[#1c1410]">
                <div className="absolute inset-0 opacity-[0.08]" style={{ backgroundImage: "radial-gradient(circle at 20% 30%, #ff5147 0, transparent 42%), radial-gradient(circle at 80% 70%, #f6b64a 0, transparent 42%)" }} />
                <PartyPopper className="text-[#ff5147]/70 transition-transform duration-500 group-hover:scale-110" size={34} />
              </div>
              <div className="p-6">
                <h3 className="font-display text-xl font-bold mb-2 text-[#f5f0ff]">{ev.title}</h3>
                <p className="text-sm text-[#9aa0c0] leading-relaxed">{ev.description}</p>
                <Link to="/reservations" className="inline-flex items-center gap-1.5 mt-4 text-sm font-semibold text-[#ff3b3b] hover:gap-3 transition-all">
                  Book this event <ArrowRight size={15} />
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
